<template>
  <el-dialog :visible.sync="showModal" append-to-body>
    <div slot="title">
      <el-row type="flex" align="middle">
        <!-- <el-col :span="2"> <el-button type="primary" size="small" @click="showModal = false">返回</el-button></el-col> -->
        <el-col :span="24"><div class="modal_title">题目&nbsp;:  &nbsp;&nbsp;&nbsp;{{title}}</div></el-col>
      </el-row>
    </div>
    <div>
      <el-button type="primary" @click="relationPaper">关联试卷</el-button>
    </div>
    <br />
    <el-table border v-loading="loading" :data="tableData" style="width: 100%">
      <el-table-column label="试卷名称" prop="title" minWidth="170" align="center">
        <template slot-scope="{row}">
          {{row.examPaper.title}}
        </template>
      </el-table-column>
      <el-table-column label="发布状态" prop="publishStatus" minWidth="170" align="center">
        <template slot-scope="{row}">
          {{row.examPaper.publishStatus | publishStatusFilter}}
        </template>
      </el-table-column>
      <el-table-column label="所属分类" prop="title" minWidth="170" align="center">
        <template slot-scope="{row}">
          <!-- {{row.examPaper.classificationId ? typeData.find(item=>item.id == row.examPaper.classificationId).name : '--'}} -->
          {{row.examPaper.examClassification.name || '--'}}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="insertDate" minWidth="170" align="center" />
      <el-table-column label="备注" prop="remarks" minWidth="170" align="center">
        <template slot-scope="{row}">
          {{row.examPaper.remarks || '--'}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="170" fixed="right">
        <template slot-scope="{row}">
          <el-button type="text" @click="action('del',row)">删除关联</el-button>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
    <div slot="footer">
      <!-- <el-button @click="showModal = false">取 消</el-button> -->
      <el-button type="primary" @click="showModal = false">关 闭</el-button>
    </div>
    <!-- 关联试卷列表 -->
    <testPaperList ref="testPaperList" @update="update" />
  </el-dialog>
</template>

<script>
import tableMoudel from "@/libs/mixins/table"

import { typeMoudel } from "../../mixins"
import { courseTypeList, publishStatus } from "../../dict"

import { examPaperTopicPage, examPaperTopicDels } from "../../api"
import testPaperList from "../../testPaper/com/testPaperList.vue"

export default {
  components: { testPaperList },
  mixins: [tableMoudel, typeMoudel],
  filters: {
    publishStatusFilter (value) {
      return value ? publishStatus.find(item => item.id == value).name : '--'
    },
  },
  data () {
    return {
      courseTypeList,
      showModal: false,
      title: '暂无题目',
      examTopicId: null,//题目id
      projectId: null
    }
  },
  methods: {
    init (id, title = '暂无题目', projectId) {
      this.title = `${title}`
      this.examTopicId = id
      this.projectId = projectId
      if (this.examTopicId) {
        this.getData()
      }
      this.showModal = true
    },
    //关联试卷
    relationPaper () {
      this.$refs.testPaperList.init(this.examTopicId, this.projectId)
    },
    update () {
      this.getData('init')
    },
    async getData () {
      const params = {
        ...this.pageInfo,
        examTopicId: this.examTopicId
      }
      const res = await examPaperTopicPage(params)
      const { records, total } = res.data
      this.total = Number(total)
      this.tableData = records
    },
    action (key, item) {
      const id = item.id
      switch (key) {
        case 'del':
          this.$confirm('确定删除关联?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const res = await examPaperTopicDels({ ids: id })
            if (res.code !== 0) return this.$message.warning(res.message)
            this.$message.success('删除成功!')
            this.getData('init')
          })
          break;

        default:
          break;
      }
    },
    submit () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.modal_title {
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 15px;
}
</style>